import { ChangeDetectorRef, Component, ElementRef, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { MatDialog as MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import _ from 'lodash';
import { IChildProject } from 'src/app/models/projects/project.model';
import { FlowType, IProofReading, Proofreading } from 'src/app/models/proofreading.model';
import { AlertService } from 'src/app/services/alert.service';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from 'src/app/services/auth.service';
import { LoaderService } from 'src/app/services/loader.service';
import { ProjectService } from 'src/app/services/project.service';
import { ProofreadingService } from 'src/app/services/proofreading.service';
import { SelectDialogOptions, SelectDialog } from 'src/app/shared/components/dialog/select-dialog/select-dialog.component';
import { ViewComponent } from 'src/app/shared/pages/view/view.component';
import { StateMachineService } from 'src/app/services/machine-state.service';


interface IThumbnail {
    src: string;
}
@Component({
    selector: 'app-project-proofreadings-statuses',
    templateUrl: './project-proofreadings-statuses.component.html',
    styleUrls: ['./project-proofreadings-statuses.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class ProjectProofreadingsStatusesComponent extends ViewComponent implements OnInit {

    protected added_flows: FlowType[] = [];

    protected _proofreadings: Proofreading[];
    @Input() set proofreadings(value: Proofreading[]) {
        this._proofreadings = value;
    };

    @Input() allowAddingFlows:boolean = true;
    
    get proofreadings(): Proofreading[] {
        return (this._proofreadings || this.s_proofreadings.entities).sort((a, b) => Object.keys(FlowType).indexOf(a.flow) - Object.keys(FlowType).indexOf(b.flow));
    }

  
    
    get project() {
        return this.s_projects.current;
    }

    get archived() {
        return this.project?.state === 'archived';
    }

    get isOldProject() {
        return this.project?.custom?.general?.is_old;
    }

    get spacingConditions() : boolean {
        const element = document.querySelector('.scroll-hide') as HTMLElement;
        return element?.offsetWidth < 600 && this.proofreadings?.length > 2;
    }

    protected disallowed_flows = [FlowType.EZD_EXE, FlowType.EZD_PDF_REPOSITORY, FlowType.PDF_REPO];

    get already_used_flows() {
        return _.uniq([...this.proofreadings?.map((pr: IProofReading) => pr.flow), ...this.added_flows]);
    }

    get available_flows() {
        const avails = _.filter(Object.values(FlowType), flow => !this.already_used_flows.includes(flow) && !this.disallowed_flows.includes(flow));
        return this.already_used_flows.includes(FlowType.EZD_EXE) ? _.without(avails, FlowType.EXE) : avails;
    }

    loading_statuses:boolean = false;

    constructor(
        protected route: ActivatedRoute,
        protected router: Router,
        protected s_alert: AlertService,
        protected s_loader: LoaderService,
        protected s_auth: AuthService,
        protected dialog: MatDialog,
        protected s_projects: ProjectService,
        protected s_proofreadings: ProofreadingService,
        protected cd: ChangeDetectorRef,
        private elRef: ElementRef,
        
        protected s_sm: StateMachineService
    ) {
        super(route, router, s_alert, s_loader, s_auth);
    }

    async ngOnInit(): Promise<void> {
    }

    get isProject(): boolean {
        return this.elRef.nativeElement && this.elRef?.nativeElement?.hasAttribute('project');
    }

  

    getPrefixRelecture(flow: FlowType) {
        return ProofreadingService.getPrefixRelecture(flow);
    }

    openCreateProofreadingModal() {
        if (!this.project) return;

        const options: SelectDialogOptions = {
            title: 'SELECT_FLOW',
            valid: 'OK',
            text: this.isProject ? 'SELECT_FLOW_ARE_YOU_SURE' : '',
            data: this.available_flows,
            defaultValue: [FlowType.EXE],
            label: 'FLOW',
            multiple: true,
        };
        this.dialog
            .open(SelectDialog, {
                panelClass: 'dialog',
                data: options,
                disableClose: true,
                width: '450px'
            })
            .afterClosed()
            .subscribe(async (response: any) => {
                
                if (!this.project) return;
                const { data } = response;
                if (!data) return;

                this.isProject ? this.loading = true : this.loading_statuses = true;
                this.cd.detectChanges(); 

                for (const flow of data) {
                    await this.s_proofreadings.create(new Proofreading({
                        project: {
                            ID: this.project._id,
                            identifier: this.project.identifier
                        },
                        flow
                    }));
                    this.cd.detectChanges(); 

                }
                this.added_flows.push(...data);
               
                this.s_proofreadings.find({ 'project.identifier': this.project?.identifier });
                this.s_projects.getCurrent(this.project._id);

                setTimeout(() => {
                    this.cd.markForCheck();

                }, 200);
                this.isProject ? this.loading = false : this.loading_statuses = false;


            });
    }


    getSlugText(next: string, intern: boolean, proofreading: IProofReading): string {
        const next_state = this.s_sm.entities.find(e => e.slug === next && e.type === (intern ? 'intern' : 'extern') && e.flow.includes(proofreading.flow));
        return next_state?.payload?.text_slug || next;
    }


}